import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  /* Generic-G80-RD-Standard-DEMO font loading */
  @font-face {
    font-family: 'Generic-G80-RD-Standard-DEMO';
    src: url('../fonts/Generic-G80-RD-Standard-DEMO.woff2') format('woff2'),
         url('../fonts/Generic-G80-RD-Standard-DEMO.otf') format('opentype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  /* Naveid Arabic DEMO font loading */
  @font-face {
    font-family: 'Naveid Arabic DEMO';
    src: url('/fonts/NaveidArabicDEMO-ExtraBold.otf') format('opentype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  /* Reset and base styles */
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    min-height: 100%;
    margin: 0;
    padding: 0;
    scroll-behavior: smooth;
  }

  body, #root {
    min-height: 100%;
    margin: 0;
    padding: 0;
  }

  body {
    font-family: 'Generic-G80-RD-Standard-DEMO', 'PP Mori', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: ${props => props.$isCorporateMode ? '#F5E5E3' : '#F20'};
    overflow-x: hidden;
    min-height: 100vh;
    transition: background-color 0.5s ease-in-out;
    cursor: auto;
  }

  /* Apply custom cursor to interactive elements */
  /* Also ensure pointer-events: auto to override parent pointer-events: none */
  /* Apply to all states - both cursor-pointer and cursor-default */
  button,
  a,
  [role="button"],
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  *[style*="cursor: pointer"],
  *[style*="cursor:pointer"],
  .vintage-button,
  button.vintage-button,
  /* Also apply when body has cursor-default class */
  body.cursor-default button,
  body.cursor-default a,
  body.cursor-default [role="button"],
  body.cursor-default input[type="button"],
  body.cursor-default input[type="submit"],
  body.cursor-default input[type="reset"],
  body.cursor-default .vintage-button,
  body.cursor-default button.vintage-button {
    cursor: url('/icons/pointer.svg') 10 0, pointer !important;
    pointer-events: auto !important;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }

  /* CameraAlignedPhoneboxLabels fade animations */
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  @keyframes fadeOut {
    from {
      opacity: 1;
      transform: translateY(0);
    }
    to {
      opacity: 0;
      transform: translateY(-10px);
    }
  }

  /* Preloader overflow prevention - use position fixed to prevent scrollbar calculation */
  html.preloader-active {
    overflow: hidden !important;
    overflow-x: hidden !important;
    overflow-y: hidden !important;
    height: 100% !important;
    width: 100% !important;
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    /* Prevent scrollbars during animation */
    overscroll-behavior: none !important;
  }

  body.preloader-active {
    overflow: hidden !important;
    overflow-x: hidden !important;
    overflow-y: hidden !important;
    height: 100vh !important;
    width: 100% !important;
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    /* Prevent scrollbars during animation */
    overscroll-behavior: none !important;
    /* Prevent any scrollbar calculation */
    margin: 0 !important;
    padding: 0 !important;
  }

  /* Preloader container - outer container strictly constrained to viewport */
  [data-preloader] {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    overflow: hidden !important;
    clip-path: inset(0) !important;
    contain: layout style paint !important;
    /* Strictly constrain to viewport - no overflow possible */
    max-width: 100vw !important;
    max-height: 100vh !important;
    min-width: 100vw !important;
    min-height: 100vh !important;
    /* Prevent the scaled element from causing scrollbars */
    isolation: isolate;
    /* Ensure nothing can overflow */
    box-sizing: border-box !important;
  }

  /* Prevent any scrollbar appearance during preloader animation */
  body.preloader-active * {
    overscroll-behavior: none !important;
  }

  /* Also prevent overflow on root element */
  #root.preloader-active {
    overflow: hidden !important;
    height: 100vh !important;
    width: 100% !important;
  }

  /* Disable pointer events on all elements during preloading */
  html.preloader-active *,
  body.preloader-active *,
  #root.preloader-active * {
    pointer-events: none !important;
  }

  /* Re-enable pointer events for the preloader and all its children */
  html.preloader-active [data-preloader],
  html.preloader-active [data-preloader] *,
  body.preloader-active [data-preloader],
  body.preloader-active [data-preloader] *,
  #root.preloader-active [data-preloader],
  #root.preloader-active [data-preloader] * {
    pointer-events: auto !important;
  }

  /* Global cursor classes applied to body - cascades to all elements */
  body.cursor-pointer,
  body.cursor-pointer *,
  body.cursor-pointer canvas {
    cursor: url('/icons/pointer.svg') 10 0, pointer !important;
  }

  body.cursor-default {
    cursor: auto !important;
  }

  /* Reset cursor for canvas when cursor-default is active */
  body.cursor-default canvas {
    cursor: auto !important;
  }

`;

export default GlobalStyles;
